import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Button, DialogContent, Dialog, DialogActions, DialogTitle, Stack, TextField, Typography } from "@mui/material";
import { route } from "preact-router";

export default function SellerStartNewDealDialog(props) {
	const [form, setForm] = useState({ descr: "" });
	const [disabled, setDisabled] = useState(false);
	const handleClose = () => {
		props.onClose();
	};
	const handleChange = (event) => {
		setForm({ ...form, [event.target.name]: event.target.value });
	};

	useEffect(() => {
		setDisabled(form.descr.length > 0);
	}, [form]);
	const handleSubmitNewDeal = () => {
		console.log("handleSubmitNewDeal");
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },

			body: JSON.stringify({
				descr: form.descr,
			}),
		};
		fetch("/api/00f47b88152b481eb8947db50f80ae44", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":


						window.location.replace("/newdealv/" + res.id + "/0");
						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};
	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog"><Typography variant="h5">Nouveau dossier de vente</Typography></DialogTitle>
			<DialogContent dividers>
				<Typography variant="h5" gutterBottom>
					Vous souhaitez démarrer un dossier de vente
				</Typography>
				<Typography variant="h5" gutterBottom>
					Nous allons créer un dossier et vous poser quelques questions pour le compléter
				</Typography>
				<Typography variant="h6" gutterBottom>
					Sous quelle appellation souhaitez-vous conserver ce dossier de vente ?
				</Typography>
				<Typography variant="body2" gutterBottom>
					Cette appellation est privée, elle ne figurera pas dans les informations publiques du dossier
				</Typography>
				<div>
					<TextField
						id="descr"
						name="descr"
						variant="outlined"
						style={{
							marginLeft: 0,
							marginRight: 10,
						}}
						placeholder="Nom du dossier de vente"
						fullWidth
						margin="dense"
						size="small"
						value={form.descr}
						onChange={handleChange}
					/>
				</div>

				<Typography variant="caption" gutterBottom>
					Ex: Ma maison de campagne, ...
				</Typography>

			</DialogContent>
			<DialogActions>
				<Stack flexDirection="row" justifyContent="space-between" alignItems={"center"} style="width: 100%">
					<Button variant="contained" onClick={handleClose}>
						Annuler
					</Button>
					<Button variant="contained" onClick={handleSubmitNewDeal} style="margin: 10px;" disabled={!disabled}>
						Continuer
					</Button>
				</Stack>
			</DialogActions>
		</Dialog>
	);
}
